export default "__VITE_ASSET__x9BEwX67__"